import * as React from 'react';
import {useEffect, useState} from 'react';
import {
    getProjectResources,
    getProjects,
    getResourceId,
    getSubscriptions,
    sort,
    toArray,
    postData,
    dataStatus
} from "./go-api";
import Authenticate from "./Authenticate";
import {Box, Grid, TextField as MuiTextField, Typography, useTheme} from "@material-ui/core";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {Autocomplete} from "@material-ui/lab";
import {createFilterOptions} from "@material-ui/lab/Autocomplete";
import Upload from "./Upload";
import {withStyles} from "@material-ui/core/styles";
import {AT_TYPE, TYPE_OWL_ONTOLOGY} from "../../Constants";
import ErrorMessage from "../ErrorMessage";

const steps = ['Authenticate', 'Upload'];

export const gridSpacing = 3;
const styles = {
    dialogPaper: {
        minWidth: '600px',
        maxWidth: '600px',
        minHeight: '68vh'
    },
};

const allowMinorIssues = true;
function UploadOntologyDialog({ontologyData, open, configuration, onCancel, classes}) {
    const projectType = "https://grafsync.graphifi.com/schema/gs/OntologyProject";
    const [activeStep, setActiveStep] = React.useState(0);
    const [showPassword, setShowPassword] = useState(false);
    const [user, setUser] = useState();

    const [subscriptions, setSubscriptions] = useState([]);
    const [projects, setProjects] = useState([]);
    const [ontologies, setOntologies] = useState([]);
    const [selectedSubscription, setSelectedSubscription] = useState();
    const [selectedProject, setSelectedProject] = useState();
    const [postDataResponse, setPostDataResponse] = useState();
    const [postDataStatus, setPostDataStatus] = useState();

    useEffect(() => {
        const loadData = async () => {
            return [];
        };

        loadData().catch(e => {});
    }, []);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleSignIn = (user) => {
        setUser(user);
        getSubscriptions(configuration, user).then(subscriptions => {
            setSubscriptions(sort(subscriptions, 'subscriptionName'))
            setActiveStep(1);
        })
    }

    const handleSubscriptionChange = (selectedSubscription) => {
        //const selectedSubscriptionId = selectedSubscription.target.value;
        setSelectedSubscription(selectedSubscription);
        const subscription = subscriptions.find(s => getResourceId(s) === getResourceId(selectedSubscription));
        getProjects(configuration, user, subscription, projectType).then(pr => {
            let projectsSorted = toArray(pr.results).map(pr => {
                const {id, title, ...rest} = pr;
                return {
                    id : getResourceId(pr),
                    title : toArray(pr.title[pr.defaultLang])[0],
                    ...rest
                }
            });
            projectsSorted = sort(projectsSorted, 'title');
            setProjects(projectsSorted);
            setSelectedProject('');
            setOntologies([]);
        });
    }

    const handleProjectChange = (selectedProject) => {

        setSelectedProject(selectedProject);
        const subscription = selectedSubscription;
        const project = projects.find(s => getResourceId(s) === selectedProject.id);
        getProjectResources(configuration, user, subscription, project).then(cs => {
            const csSorted = toArray(cs.graph).map(pr => {
                const {id, title, ...rest} = pr;
                return {
                    id : getResourceId(pr),
                    title : toArray( pr.title[project.defaultLang])[0] || getResourceId(pr),
                    rest
                }
            });
            setOntologies(csSorted);
        });
    }


    const handleUpload = () => {
        //refreshUploadStatus();
        //return;
        let options = [{
            "property": "https://grafsync.graphifi.com/schema/gs/useSlashIRI",
            "value": true
        }, {
            "property": "https://grafsync.graphifi.com/schema/gs/useUuidIRI",
            "value": false
        }, {"property": "https://grafsync.graphifi.com/schema/gs/allowMinorIssues", "value": allowMinorIssues}]

        postData(configuration, user, selectedProject.id, selectedSubscription, ontologyData, "Ontology.jsonld", options).then(r => {
            setPostDataResponse(r);
            refreshUploadStatus(r);
        })
    }

    const refreshUploadStatus = (postDataResponse) => {
        dataStatus(configuration, user, selectedSubscription, postDataResponse).then(r => {
            setPostDataStatus(r);
            if(r.transfer === undefined) {
                setTimeout(refreshUploadStatus, 1000, postDataResponse);
            }
        })
    }

    const subscriptionFilterOptions = createFilterOptions({
        matchFrom: "any",
        stringify: (option) => {
            return option.subscriptionName + option.id;
        }
    });

    const projectsFilterOptions = createFilterOptions({
        matchFrom: "any",
        stringify: (option) => {
            return option.title + option.id;
        }
    });

    const undefinedToNull = (v) => {
        return v === undefined ? null : v;
    }

    const renderStatus = () => {
        return <Upload
            message={undefinedToNull(postDataStatus.message)}
            transfer={undefinedToNull(postDataStatus.transfer)}
            status={toArray(undefinedToNull(postDataStatus.status))}
            issueManagement={false}
            allowMinorIssues={allowMinorIssues}
            stepCount={undefinedToNull(postDataStatus.stepCount)}
            normalisation={undefinedToNull(postDataStatus.normalisation) }
        />;
    }

    const uploadOntologyId = ontologyData.find( o => toArray(o[AT_TYPE] || o.type).includes(TYPE_OWL_ONTOLOGY));

    const getStepContent = () => {
        switch(activeStep) {
            case 0:
                return <>
                    <Authenticate onSuccess={handleSignIn} configuration={configuration}></Authenticate>
                </>;
            case 1:
                const alreadyExists = ontologies.find(o => getResourceId(o) === getResourceId(uploadOntologyId));
                return <>
                    {
                        postDataStatus ? renderStatus() :
                    <Grid sx={{marginTop : '16px'}} container spacing={gridSpacing}>
                        <Grid item xs={12}>
                            <Autocomplete
                                size={'small'}
                                datatest={'Subscription-select'}
                                id="Subscription-select"
                                freeSolo
                                value={selectedSubscription}
                                style={{  ...{} }}
                                options={subscriptions}
                                filterOptions={(x) => x}
                                getOptionLabel={(option) => (typeof option === 'string' ? option : option.subscriptionName)}
                                onChange={(event, newValue, reason) => {
                                    if (reason === 'select-option') {
                                        handleSubscriptionChange(newValue)
                                    }
                                }}
                                renderInput={(params) => (
                                    <MuiTextField {...params} label="Subscription" margin="normal" variant="outlined" />
                                )}
                                renderOption={(option) => {
                                    return (
                                        <Grid container alignItems="center">
                                            <Grid item xs>
                                                <Typography variant="h3" color="textSecondary">
                                                    {option.subscriptionName || getResourceId(option)}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    );
                                }}
                                filterOptions={subscriptionFilterOptions}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                size={'small'}
                                disabled={!selectedSubscription}
                                datatest={'Project-select'}
                                id="Project-select"
                                freeSolo
                                value={selectedProject}
                                style={{  ...{} }}
                                options={projects}
                                filterOptions={(x) => x}
                                getOptionLabel={(option) => (typeof option === 'string' ? option : option.title)}
                                onChange={(event, newValue, reason) => {
                                    if (reason === 'select-option') {
                                        handleProjectChange(newValue)
                                    }
                                }}
                                renderInput={(params) => (
                                    <MuiTextField {...params} label="Project" margin="normal" variant="outlined" />
                                )}
                                renderOption={(option) => {
                                    return (
                                        <Grid container alignItems="center">
                                            <Grid item xs>
                                                <Typography variant="h3" color="textSecondary">
                                                    {option.title || getResourceId(option)}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    );
                                }}
                                filterOptions={projectsFilterOptions}
                            />

                        </Grid>

                        <Grid item xs={12}>
                            {alreadyExists && <ErrorMessage error={"Ontology already exists in the project."}></ErrorMessage>}
                        </Grid>
                        <Grid item xs={12}>
                            <Button disabled={alreadyExists || !selectedSubscription || !selectedProject} color={'secondary'} variant={'outlined'} fullWidth={true} onClick={handleUpload}>Upload</Button>
                        </Grid>
                    </Grid>
                    }
                </>;
        }



    }

    return (
        <Dialog
            maxWidth={"sm"}
            aria-labelledby="Upload Ontology"
            open={open}
            fullWidth={true}
            datatest={'uploadOntologyDialog'}
            classes={{ paper: classes.dialogPaper }}
        >
            <DialogContent>
        <Box sx={{ width: '100%' }}>
            {
                postDataStatus?.transfer === true ? <div style={{marginTop : '72px'}}>{renderStatus()}</div> :
                <>
                    <Stepper activeStep={activeStep}>
                        {steps.map((label, index) => {
                            const stepProps = {};
                            const labelProps = {};
                            return (
                                <Step key={label} {...stepProps}>
                                    <StepLabel {...labelProps}>{label}</StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                    {getStepContent()}
                </>
            }
        </Box>
            </DialogContent>
            <DialogActions>
                <div style={{flexGrow : '1'}}></div>
                <Button
                    datatest={'closeButton'}
                    variant={"outlined"}
                    color="secondary"
                    onClick={onCancel}
                >{postDataStatus ? "Close": "Cancel"}</Button>
            </DialogActions>
        </Dialog>
    );
}

export default withStyles(styles, {withTheme: true})(UploadOntologyDialog);
